function isLoggedIn() {
    // 从localStorage中读取token
    const token = localStorage.getItem('token');

    // 如果token存在，则表示已经登录
    return token !== null;
}

export default isLoggedIn;